import styled from '@emotion/styled'
import React, { Dispatch, SetStateAction } from 'react'
import { DatePickerInclusive, DatePicker } from '../components/DatePicker'
import { useGetEntrances } from '../lib/hooks/api'
import Checkbox from './Checkbox'
import { ActionDropDown, DropDown } from './Dropdown'
import { Text14 } from './Text'
const NavBarStyle = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center; 
}
`

export const Navbar = ({
  setStart,
  setEnd,
  start,
  setEntrance,
  handleDownloadPNG,
  handleDownloadCSV,
  isChecked,
  setIsChecked,
}: {
  setStart: Dispatch<SetStateAction<number>>
  setEnd: Dispatch<SetStateAction<number>>
  start: Date
  setEntrance: Dispatch<SetStateAction<string>>
  handleDownloadPNG: () => Promise<void>
  handleDownloadCSV: () => Promise<void>
  isChecked: boolean
  setIsChecked: Dispatch<SetStateAction<boolean>>
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(e.target.checked)
  }

  const { data: entrances = [] } = useGetEntrances()
  return (
    <NavBarStyle>
      <Text14>From</Text14>
      <DatePicker name="startDate" setDate={setStart} />
      <Text14>To</Text14>
      <DatePickerInclusive
        name="finishDate"
        setDate={setEnd}
        min={start.toLocaleDateString('sv')}
      />
      <Text14>Toggle Weather</Text14>
      <Checkbox handleChange={handleChange} isChecked={isChecked} />
      <Text14>Select Entrance</Text14>
      <DropDown
        menuItems={['All', ...entrances.map((item) => item.name)]}
        defaultVal={0}
        mapping={{
          All: '',
          ...Object.fromEntries(
            entrances.map((item) => [item.name, item.name]),
          ),
        }}
        callBack={setEntrance}
      />
      <ActionDropDown
        actionItems={[
          { name: 'PNG', action: handleDownloadPNG },
          { name: 'CSV', action: handleDownloadCSV },
        ]}
      />
    </NavBarStyle>
  )
}
